<template>
  <v-navigation-drawer app v-model="drawer" width="300" dark>
    <div class="d-flex flex-column">
      <StoreSelector contentClass="ma-4" />
      <v-divider />
      <div class="d-flex flex-column gap-6 pa-4">
        <div
          v-for="item in menuItems"
          :key="item.title"
          class="d-flex flex-column gap-2 mx-1"
        >
          <span class="text-overline white--text">{{ item.title }}</span>
          <div v-for="child in item.children" :key="child.title">
            <v-btn
              :to="child.to"
              text
              block
              class="text-capitalize justify-start rounded-lg"
              large
            >
              <v-icon left>{{ child.icon }}</v-icon>
              {{ child.title }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import StoreSelector from "@/components/global/StoreSelector.vue";
export default {
  name: "NavigationDrawer",
  components: {
    StoreSelector,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    menuItems: [
      {
        title: "Clientes",
        children: [
          {
            title: "Lista",
            icon: "mdi-account",
            to: "/app/clients",
          },
        ],
      },
      {
        title: "Equipamentos",
        children: [
          {
            title: "Registros",
            icon: "mdi-history",
            to: "/app/devices/logs",
          },
          {
            title: "Gerenciar",
            icon: "mdi-cellphone-link",
            to: "/app/devices/management",
          },
        ],
      },
    ],
  }),
  computed: {
    drawer: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
